import React from 'react'
import { Spinner } from 'react-bootstrap'

const Loader = () => {
  return (
      <React.Fragment>
    <Spinner
      animation='border'
      className="mt-5"
      role='status'
      style={{
        width: '100px',
        height: '100px',
        margin: 'auto',
        display: 'block',
      }}
    >
      <span className='sr-only'>Ladataan tietoja...</span>
    </Spinner>
    <h3 className="col-md-2 mt-5" style={{   
        margin: 'auto',
        display: 'block',
        textAlign: 'center'
      }}>Ladataan tietoja</h3>
    </React.Fragment>
  )
}

export default Loader